import { DestroyRef, Directive, ElementRef, Input, OnInit, Renderer2, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTooltip } from '@angular/material/tooltip';
import { SubscriptionService } from 'taxtank-core';

/**
 * Disables actions for users without an active paid subscription
 * and shows a tooltip explaining why it's disabled
 */
@Directive({
  selector: '[appTrialAccess]',
  hostDirectives: [MatTooltip]
})
export class TrialAccessDirective implements OnInit {
  @Input() tooltipMessage = '';

  private readonly el = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly subscriptionService = inject(SubscriptionService);
  private readonly tooltip = inject(MatTooltip);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.subscriptionService.get()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(subscriptions => {
        if (subscriptions.getActivePaid()) {
          return;
        }

        this.el.nativeElement.addEventListener('click', (event: Event): void => {
          event.preventDefault();
          event.stopPropagation();
        }, true);

        this.renderer.setProperty(this.el.nativeElement, 'disabled', true);

        this.tooltip.message = this.tooltipMessage;
      });
  }
}
